const APIConfig = {
    graphql_endpoint: process.env.REACT_APP_GRAPHQL_ENDPOINT,
    graphql_headers: async () => ({})    
};
  
export default APIConfig